module.exports = __webpack_public_path__ + "static/img/empty-jzx.b35226db.png";